module.exports = __webpack_public_path__ + "fonts/title.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/svgs/title.svg
// module id = 606
// module chunks = 5